import { render, staticRenderFns } from "./EditTitle.vue?vue&type=template&id=28f76508&"
import script from "./EditTitle.vue?vue&type=script&lang=js&"
export * from "./EditTitle.vue?vue&type=script&lang=js&"
import style0 from "./EditTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports